// @vendors
const Immutable = require('immutable');

// @helpers
const { formatText } = require('core/i18n').i18n;

const {
    BROKER_CONVENIENCE_MIFID_TEST_VALIDATE_STEP,
    BROKER_CONVENIENCE_MIFID_TEST_STEP0_CHANGE_UPDATE_REASON,
} = require('mifid/constants/actionTypes');

const getInitialState = () => {
    return Immutable.fromJS({
        updateReason: {
            id: '125',
            orden: '-1',
            question: formatText('broker-convenienceMifidTestConvenienceStep0Subtitle1'),
            answer: '',
            answers: [
                {
                    id: '126',
                    description: formatText(
                        'broker-convenienceMifidTestConvenienceStep0OptionLabel1'
                    )
                },
                {
                    id: '127',
                    description: formatText(
                        'broker-convenienceMifidTestConvenienceStep0OptionLabel2'
                    )
                },
            ],
        },
        summaryTitle: formatText(
            'broker-convenienceMifidTestUpdateReasonSummaryTitle'
        ),
        summaryDescription: [],
        valid: false,
        validated: false
    })
}

function changeUpdateReason(immState, updateReason) {
    return immState.setIn(['updateReason', 'answer'], updateReason);
}

function validateStep(immStep) {
    const updateReasonAnswered = !!immStep.getIn(['updateReason', 'answer']);
    return immStep.set('valid', updateReasonAnswered).set('validated', true);
}

function brokerConvenienceMiFIDTestStep0(state = getInitialState(), action) {
    switch (action.type) {
        case BROKER_CONVENIENCE_MIFID_TEST_VALIDATE_STEP:
            return validateStep(state);
        case BROKER_CONVENIENCE_MIFID_TEST_STEP0_CHANGE_UPDATE_REASON:
            return changeUpdateReason(state, action.payload.updateReason);
        default:
            return state;
    }
}

module.exports = brokerConvenienceMiFIDTestStep0;